import { render, staticRenderFns } from "./open-invoice-cart.vue?vue&type=template&id=22c4bc76"
import script from "./open-invoice-cart.vue?vue&type=script&lang=js"
export * from "./open-invoice-cart.vue?vue&type=script&lang=js"
import style0 from "./open-invoice-cart.vue?vue&type=style&index=0&id=22c4bc76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports